var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('b-notification',{attrs:{"type":"is-warning","has-icon":"","aria-close-label":"Close notification","role":"alert","closable":false}},[_vm._v(" La aplicación solicitada no existe! ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }